export default {
  /**
   * @description 配置显示在浏览器标签的title
   */
  title: 'OA管理系统',
  /**
   * @description token在Cookie中存储的天数，默认1天
   */
  cookieExpires: 0.5,
  /**
   * @description 是否使用国际化，默认为false
   *              如果不使用，则需要在路由中给需要在菜单中展示的路由设置meta: {title: 'xxx'}
   *              用来在菜单中显示文字
   */
  useI18n: false,
  webConfig: {
    webTitle: 'OA管理系统',
  },
  /** http://fslzz@81.68.171.253:10101/r/XITAMES.git
   * @description 默认打开的首页的路由name值，默认为home
   */
  homeName: 'home',
  storageOptions: {
    namespace: 'cqt__', // key prefix
    name: 'ls', // name variable Vue.[ls] or this.[$ls],
    storage: 'local', // storage name session, local, memory
  },

  oldDataIp: 'http://120.78.177.70:9137',

  /** AuthCenter 统一认证后端 API：
   *  测试 http://localhost:5173
   *  正式 https://authapi.lockhea.com
   */
  authCenterBaseUrl:
    process.env.VUE_APP_AUTH_CENTER_URL || 'http://localhost:5173',
  authCenterClientId: 'oa',
  /** 是否使用 AuthCenter 统一认证登录，true 时登录页跳转 AuthCenter */
  useAuthCenterLogin: true,
};
